import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Single-source-of-truth for "which dropdown is currently open?". Any
 * dropdown that wants to participate in mutual exclusion subscribes to
 * `current$` and closes itself when another id becomes the current one.
 *
 * Each dropdown instance should mint its own `Symbol()` and use it as the
 * id so collisions are impossible without coordinating on string names.
 */
@Injectable({ providedIn: 'root' })
export class DropdownCoordinatorService {

  private readonly openId$ = new BehaviorSubject<symbol | null>(null);

  readonly current$: Observable<symbol | null> = this.openId$.asObservable();

  /** Mark this dropdown as the currently open one. */
  open(id: symbol): void {
    if (this.openId$.value !== id) {
      this.openId$.next(id);
    }
  }

  /** Clear the open state, but only if this id is the one currently open. */
  close(id: symbol): void {
    if (this.openId$.value === id) {
      this.openId$.next(null);
    }
  }
}
